module.exports = __webpack_public_path__ + "static/lframe-boat-loan-fb1811cd2d7b4caa80016a0cfdbe14c3.png";